import { Fix64 } from "../maths/fix64";
import { Enemy } from "./entities";
import { SimEventKind } from "./events";
import type { LevelSim } from "./levelSim";
import { applyPetHit, petCanReach, strongestInReach } from "./petStatus";
import type { PetSystem } from "./petSystem";

/**
 * A Pets v3 signature (docs/PETS.md "Pets v3": Moonfall, Wildfire, Spire Quake, Bubble Trap, Starfall), as the pup's Howl:
 * once a wave (each stage that starts arms it again), the first tick a raider (flyers too when `air`) is within `reach`
 * of the flag, every raider there (or only the one with most health when `strongest`) takes its hit. PetHowled
 * (a = raiders hit, b = the stun's ticks or 0, c = the stage).
 */
export function tickSignature(sim: LevelSim, pet: PetSystem): void {
  const s = pet.rule.signature;
  if (!s || pet.signatureStage >= sim.stage) return;
  const r = sim.troops.rally, fx = Fix64.fromInt(r.x), fy = Fix64.fromInt(r.y), r2 = s.reach.mul(s.reach);
  let any = false;
  for (const e of sim.enemySlots) if (petCanReach(sim, e, s.air, fx, fy, r2)) { any = true; break; }
  if (!any) return;
  pet.signatureStage = sim.stage;
  let hit = 0;
  if (s.strongest) {
    const e = strongestInReach(sim, s.air, fx, fy, r2);
    if (e !== null) { applyPetHit(sim, e, s.hit); hit = 1; }
  } else {
    const list: Enemy[] = pet.scratch;
    list.length = 0;
    for (const e of sim.enemySlots) if (petCanReach(sim, e, s.air, fx, fy, r2)) list.push(e);
    for (const e of list) applyPetHit(sim, e, s.hit);
    hit = list.length;
    list.length = 0;
  }
  sim.events.add(SimEventKind.PetHowled, hit, s.hit.stunTicks, sim.stage);
}
